import Vue from "vue";
import Vuex from "vuex";
import { getSavedState, saveState } from "../utils";
import { authService, userService } from "../services";

Vue.use(Vuex);
export const store = new Vuex.Store({
    state: {
        //CliendListState

        gelen: "",
        perpage: "",
        status: "",
        count: "",
        totalPage: "",
        limit: "",
        page: "",
        data: [{
            documentIdDate: "",
            documentCount: "",
            cc: "",
            name: "",
            clientIdData: "",
            Schriftverkehr: "",
            Buchhaltung: "",
            Personal: "",
            Vertrage: "",
            Kanzleipost: "",
            Personliches: "",
            unusedBarcode: ""
        }],

        //searchStoreState
        lang: "",
        dataOCR: "",
        documentOCR: "",

        //Account State
        currentUser: getSavedState("auth.currentUser"),
        user: null,
        packageList: null,
        linkquarycc: "",
        linkquaryname: "",
        linkStartDate: "",
        linkEndDate: "",

        isExpand: false,
        isLoading: false
    },
    mutations: {
        getExpandMutation(state, data) {
            state.isExpand = data;
        },
        getLoadingMutation(state, data) {
            state.isFilter = data;
        },
        addrepoClientList(state, data) {
            state.gelen = data;
        },
        addStatus(state, data) {
            state.status = data
        },
        addLinkStartDate(state, data) {
            state.linkStartDate = data;
        },
        addLinkEndDate(state, data) {
            state.linkEndDate = data;
        },
        addLinkquarycc(state, data) {
            state.linkquarycc = data;
        },
        addLinkquaryname(state, data) {
            state.linkquaryname = data;
        },
        addPerPage(state, data) {
            state.perpage = data;
        },
        addLangMutation(state, data) {
            state.lang = data;
        },
        getDataOcrMutation(state, data) {
            state.dataOCR = data;
        },
        getDocumentOcrMutation(state, data) {
            state.documentOCR = data;
        },
        SET_CURRENT_USER(state, status) {
            state.currentUser = status;
            if (status !== null) {
                saveState("auth.currentUser", status);
            } else {
                localStorage.removeItem("quaryName");
                localStorage.removeItem("quaryStartDate");
                localStorage.removeItem("quaryEndDate");

            }
        },
        SET_TOKENS(state, tokens) {
            if (tokens !== null) {
                Object.keys(tokens).forEach(key => {
                    saveState(key, tokens[key]);
                });
            } else {
                localStorage.removeItem("quaryName");
                localStorage.removeItem("quaryStartDate");
                localStorage.removeItem("quaryEndDate");

            }
        },
        SET_USER_DETAIL(state, detail) {
            state.user = detail;
        },
        SET_PACKAGE_LIST(state, payload) {
            state.packageList = payload;
        }
    },
    actions: {
        addExpandAction(context, data) {
            context.commit("getExpandMutation", data);
        },
        getLoadingAction({ commit }, data) {
            commit("getLoadingMutation", data);
        },
        addRepoClientList(context, data) {
            context.commit("addrepoClientList", data);
        },
        addLinkStartDateActions({ commit }, data) {
            commit("addLinkStartDate", data);
        },
        addLinkEndDateActions({ commit }, data) {
            commit("addLinkEndDate", data);
        },
        addLinkquaryccActions({ commit }, data) {
            commit("addLinkquarycc", data);
        },
        addLinkquarynameActions({ commit }, data) {
            commit("addLinkquaryname", data);
        },
        addPerPageAction(context, data) {
            context.commit("addPerPage", data);
        },
        addLangAction(vuexContext, data) {
            vuexContext.commit("addLangMutation", data);
        },
        addDataOcrAction(vuexContext, data) {
            vuexContext.commit("getDataOcrMutation", data);
        },
        addDocumentOcrAction(vuexContext, data) {
            vuexContext.commit("getDocumentOcrMutation", data);
        },
        logIn({ commit, dispatch, getters }, { username, password }) {
            if (getters.loggedIn) return dispatch("validate");
            return authService.login(username, password).then(tokens => {
                commit("SET_TOKENS", tokens);
                commit("SET_CURRENT_USER", true);
                saveState("user", username);
                return tokens;
            });
        },
        logOut({ commit }) {
            commit("SET_CURRENT_USER", null);
            commit("SET_TOKENS", null);
            commit("SET_USER_DETAIL", null);
        },
        getUserDetail({ commit }) {
            return userService
                .fetchUserDetail()
                .then(detail => {
                    commit("SET_USER_DETAIL", detail);
                    return detail;
                })
                .catch(() => {
                    commit("SET_USER_DETAIL", null);
                    throw "detail_could_not_get";
                });
        },
        validate({ commit, state, dispatch }) {
            if (!state.currentUser) return Promise.resolve(null);
            const user = getSavedState("user");
            return userService
                .validateUserSession()
                .then(() => {
                    if (
                        state.user === null ||
                        (state.user && state.user.username !== user)
                    ) {
                        dispatch("getUserDetail");
                    }
                    commit("SET_CURRENT_USER", true);
                    return true;
                })
                .catch(() => {
                    commit("SET_CURRENT_USER", null);
                    return false;
                });
        }
    },

    getters: {
        showStatus(state) {
            return state.status;
        },
        showİsLoading(state) {
            return state.isFilter;
        },
        showExpand(state) {
            return state.isExpand;
        },
        showRepoClientList(state) {
            return state.gelen;
        },
        getLinkStartDate(state) {
            return state.linkStartDate;
        },
        getLinkEndDate(state) {
            return state.linkEndDate;
        },
        getLinkquarycc(state) {
            return state.linkquarycc;
        },
        getLinkquaryname(state) {
            return state.linkquaryname;
        },
        getLang(state) {
            return state.lang;
        },
        getPerpage(state) {
            return state.perpage;
        },
        getDataOCR(state) {
            return state.dataOCR;
        },
        getDocumentOCR(state) {
            return state.documentOCR;
        },
        loggedIn(state) {
            return !!state.currentUser;
        },
        gettersUserİmageFolder(state) {
            return state.user;
        }
    }
});

export default store;